export type MemoryCell = [state: number[], action: number, reward: number, nextState: number[] | null];

export class Memory {
	private readonly maxMemory: number;
	private readonly samples: MemoryCell[] = [];

	constructor(maxMemory: number) {
		this.maxMemory = maxMemory;
	}

	get length(): number {
		return this.samples.length;
	}

	addSample(sample: MemoryCell) {
		this.samples.push(sample);
		if (this.samples.length > this.maxMemory) {
			this.samples.shift();
		}
	}

	sample(nSamples: number): MemoryCell[] {
		const n = this.samples.length;
		if (n === 0) {
			return [];
		}
		if (nSamples >= n) {
			return [...this.samples];
		}
		const seen = new Set<number>();
		const out: MemoryCell[] = [];
		while (out.length < nSamples) {
			const i = (Math.random() * n) | 0;
			if (!seen.has(i)) {
				seen.add(i);
				out.push(this.samples[i]);
			}
		}
		return out;
	}
}
